<template>
  <SfModalMessage variant="">
    <div class="sf-level" data-testid="block-proposals">
      <SfToggle
        :model-value="!proposalsBlocked"
        @click="toggleProposalsBlocked"
      />

      <div class="text-left">
        <span>
          {{
            I18n.t('reconciliation_proposal.actions.allow_further_changes', {
              item: workflowName,
            })
          }}
        </span>

        <span
          class="fa fa-info-circle sf-pad-l-1"
          data-toggle="tooltip"
          :title="tooltipTitle"
        />
      </div>
    </div>
  </SfModalMessage>
</template>

<script type="text/javascript">
import { SfModalMessage } from '@app/shared/vue/components/sf-modal'
import SfToggle from '@app/shared/vue/components/sf-toggle'

export default {
  name: 'BlockProposals',
  components: { SfModalMessage, SfToggle },
  props: {
    workflowName: {
      type: String,
      default: '',
    },
    proposalsBlocked: {
      type: Boolean,
    },
  },
  emits: ['toggle-proposal-blocking'],
  computed: {
    tooltipTitle: () =>
      I18n.t('reconciliation_proposal.actions.allow_further_changes_tooltip'),
  },
  mounted() {
    $(document).trigger('tooltipsRendered')
  },
  methods: {
    toggleProposalsBlocked() {
      this.$emit('toggle-proposal-blocking')
    },
  },
}
</script>
